/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Base_Unresolved_ObservationsInputs */

const es_co2_error_base_unresolved_observations = /** @type {(inputs: Error_Base_Unresolved_ObservationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El formulario tiene observaciones sin resolver de una revisión anterior.`)
};

/**

* @param {Error_Base_Unresolved_ObservationsInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_base_unresolved_observations = /** @type {((inputs?: Error_Base_Unresolved_ObservationsInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Base_Unresolved_ObservationsInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_base_unresolved_observations(inputs)
});